// extracted by mini-css-extract-plugin
export var boxItems = "_7e-1";
export var boxItemsLg = "_7e-2";
export var button = "_7e-7";
export var buttonLg = "_7e-8";
export var filterGroupBox = "_7e-0";
export var icon = "_7e-3";
export var iconSecondary = "_7e-6";
export var iconWrapper = "_7e-4";
export var iconWrapperLg = "_7e-5";